import React from 'react';
import { getParentPageTitle,getParentPage } from './CommonFunctions';

export const SiteCatalyst = (SiteCatalystData) => {
    let title = getParentPageTitle();
    let PreviousPageName = getParentPage();
    return (
        <React.Fragment>
            <input type="hidden" id="USERID" value=""/>
            <input type="hidden" id="pageName" value={SiteCatalystData.PageDetails[0].pageName}/>
            <input type="hidden" id="detailPageName" value={SiteCatalystData.PageDetails[0].detailPageName}/>
            <input type="hidden" id="contentChannel" value={SiteCatalystData.PageDetails[0].contentChannel}/>
            <input type="hidden" id="events" value={SiteCatalystData.PageDetails[0].events}/>
            <input type="hidden" id="parentPage_PageTitle" value={title}/>
            <input type="hidden" id="parentPageTitle" value={title}/>
            <input type="hidden" id="currentPageTitle" value={SiteCatalystData.PageDetails[0].pageTitle}/>   
            <input type="hidden" id="previouspagename" value={PreviousPageName}/>         
        </React.Fragment>
    )
}


// WEBPACK FOOTER //
// ./src/components/modules/SiteCatalyst.js